/* eslint-disable import/prefer-default-export */
export const ADD_PRODUCTS = 'ADD_PRODUCTS';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const SHOW_PRODUCTS = 'SHOW_PRODUCTS';

export const REMOVE_SHOWCASE = 'REMOVE_SHOWCASE';
export const TEAM_SEARCH = 'TEAM_SEARCH';
export const ORDER_PRICE_UP = 'ORDER_PRICE_UP';
export const ORDER_PRICE_DOWN = 'ORDER_PRICE_DOWN';
export const PRICE_UP = 'PRICE_UP';
export const PRICE_DOWN = 'PRICE_DOWN';
export const ORDER_TEAM = 'ORDER_TEAM';
export const FILTER_TYPE = 'FILTER_TYPE';

export const ADD_CART = 'ADD_CART';
export const REMOVE_CART = 'REMOVE_CART';

export const ADD_QUANTITY = 'ADD_QUANTITY';
export const REMOVE_QUANTITY = 'REMOVE_QUANTITY';
export const ADD_SIZE_PRODUCT = 'ADD_SIZE_PRODUCT';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ADMIN = 'LOGIN_ADMIN';

export const USER_REQUEST = 'USER_REQUEST';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_UPDATE_PHOTO = 'USER_UPDATE_PHOTO';
export const USER_UPDATE_PROFILE = 'USER_UPDATE_PROFILE';
export const USER_UPDATE_ADDRESS = 'USER_UPDATE_ADDRESS';
export const USER_UPDATE_PHONES = 'USER_UPDATE_PHONES';

export const PERSIST_REHYDRATE = 'persist/REHYDRATE';
